<template>
  <div>
    <!-- 添加文章管理对话框 -->
    <el-dialog
      title='添加文章管理'
      :visible.sync='addDialogVisible'
      width='60%'
      @close='addDialogClosed'
      append-to-body
    >
      <el-form
        ref='addFormRef'
        :model='addForm'
        :rules='rules'
        label-width='100px'
      >
        <el-row>
          <!--标题-->
          <el-col :span='12'>
            <el-form-item label='标题' prop='title'>
              <el-input v-model='addForm.title' placeholder='请输入标题' />
            </el-form-item>
          </el-col>

          <!--是否顶置-->
          <el-col :span='12'>
            <el-form-item label='列表页置顶' prop='top'>
              <el-select v-model='addForm.top' clearable placeholder='请选择是否顶置' style='width: 100%'>
                <el-option key='TRUE' label='是' value='TRUE'></el-option>
                <el-option key='FALSE' label='否' value='FALSE'></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!--是否启用-->
          <el-col :span='12'>
            <el-form-item label='是否启用' prop='enumEnable'>
              <el-select v-model='addForm.enumEnable' clearable placeholder='请选择是否启用' style='width: 100%'>
                <el-option key='NORMAL' label='是' value='NORMAL'></el-option>
                <el-option key='DISABLE' label='否' value='DISABLE'></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!--属性-->
          <el-col :span='12'>
            <el-form-item label='属性' prop='enumAttribute'>
              <el-select v-model='addForm.enumAttribute' clearable placeholder='请选择属性' style='width: 100%'>
                <el-option v-for='item in optionsAttribute' :key='item.value' :label='item.label'
                           :value='item.value'></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!--排序-->
          <el-col :span='12'>
            <el-form-item label='排序' prop='sort'>
              <el-input v-model='addForm.sort' placeholder='请输入排序' oninput="value=value.replace(/[^\d]/g,'')" />
            </el-form-item>
          </el-col>

          <!--上传方式-->
          <el-col :span='12'>
            <el-form-item label='上传方式' prop='choose'>
              <el-select v-model='addForm.choose' clearable placeholder='请选择上传方式' style='width: 100%'>
                <el-option key='YES' label='文章内容' value='YES'></el-option>
                <el-option key='NO' label='跳转地址' value='NO'></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!--跳转地址-->
          <el-col :span='12' v-if="addForm.choose === 'NO'">
            <el-form-item label='跳转地址' prop='link'>
              <el-input v-model='addForm.link' placeholder='请输入跳转地址' />
            </el-form-item>
          </el-col>

          <!--是否显示在首页-->
          <el-col :span='12'>
            <el-form-item label='首页显示' prop='index'>
              <el-select v-model='addForm.index' clearable placeholder='请选择是否显示在首页' style='width: 100%'>
                <el-option key='YES' label='是' value='YES'></el-option>
                <el-option key='NO' label='否' value='NO'></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!--添加标签-->
          <el-col :span='12'>
            <el-form-item label='添加标签'>
              <el-select v-model='addForm.labelIds' multiple clearable placeholder='请选择添加标签' style='width: 100%'>
                <el-option
                  v-for='item in optionsLabel'
                  :key='item.id'
                  :label='item.name'
                  :value='item.id'>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span='12'>
            <el-form-item label='更新时间'>
              <el-date-picker v-model='addForm.releaseTime' placeholder='请选择更新时间' type='date'
                              value-format='timestamp'></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='跳转到商品' prop='goodsFlag'>
              <el-switch
                v-model="addForm.goodsFlag"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0">
              </el-switch>
            </el-form-item>
          </el-col>

          <!--简介-->
          <el-col :span='24'>
            <el-form-item label='备注说明'>
              <el-input type='textarea' v-model='addForm.brief' placeholder='请输入备注说明' />
            </el-form-item>
          </el-col>

          <!--选择商品-->
          <el-col :span='24' v-if='addForm.goodsFlag == 1'>
            <el-form-item label='商品' prop='goodsId'>
              <el-select v-model="addForm.goodsId" placeholder="请选择商品">
                <el-option style='width: 100%;'
                  v-for="item in vipGoodsList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>


          <!--缩略图-->
          <el-col :span='24'>
            <el-form-item label='缩略图' prop='thumbnail'>
              <thumbnail v-model='addForm.thumbnail' :autoCropWidth='800' :autoCropHeight='500'
                         :fixedNumber='[16,10]'></thumbnail>
            </el-form-item>
          </el-col>

          <!--富文本-->
          <el-col :span='24' v-if="addForm.choose === 'YES' && addForm.goodsFlag == 0">
            <!--            <Editor ref="getEditor" v-model="addForm.content" :type="'html'"></Editor>-->
            <yk-editor ref='editorRef' v-model='addForm.content'></yk-editor>
          </el-col>

        </el-row>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button @click='cancel'>取 消</el-button>
        <el-button @click='addArticle'>确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addArticle } from '@/api/article/article'
import { getData } from '@/utils/code'
/*import Editor from '@/components/common/editor/editor'*/
import Thumbnail from '@/components/common/thumbnail/thumbnails'
import { getLabelList } from '@/api/label/label'
import { vipGoods } from '@/api/goods/goods'
import { articleAttribute } from '@/js/enum.js'
import { articleRules } from '@/js/rules'
import ykEditor from '@/components/common/ckeditor/ckeditor'

export default {
  name: 'addArticle',
  components: { Thumbnail, /*Editor*/ ykEditor },
  data() {
    return {
      addForm: {
        goodsFlag: 0
      }, //添加组织表单
      addDialogVisible: false,
      optionsLabel: [],
      optionsAttribute: articleAttribute,
      rules: articleRules,
      vipGoodsList: []
    }
  },
  created() {
    this.getLabelList()
    this.loadGoods()
  },
  methods: {
    //关闭模态框
    cancel() {
      this.addDialogVisible = false
      // this.addForm = {}
    },

    //获取标签
    getLabelList() {
      const query = {
        current: 1,
        size: 10
      }
      getLabelList(query).then(res => {
        this.optionsLabel = res.code === '0' ? res.data.records : []
      })
    },

    //模态框
    addDialog() {
      this.addDialogVisible = true
    },

    // 监听添加用户对话框的关闭事件 /  重置表单
    addDialogClosed() {
      this.$refs.addFormRef.resetFields()
      this.addForm = {}
    },
    getHtml(html) {
      let str = html.replace('<figure', '<div')
      return str.replace('</figure>', '<div>')
    },
    loadGoods() {
      vipGoods().then(res => {
        this.vipGoodsList = res.data
      })
    },
    // 添加
    addArticle() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        if (this.addForm.choose === 'YES' && !this.addForm.content && this.addForm.goodsFlag == 0) {
          return this.$message.error('文章内容不能为空')
        }
        if (this.addForm.choose === 'NO' && !this.addForm.link && this.addForm.goodsFlag == 0) {
          return this.$message.error('跳转地址不能为空')
        }
        if (this.addForm.goodsFlag == 1) {
          if (!this.addForm.goodsId) {
            return this.$message.error('商品不能为空')
          }

        } else {
          this.addForm.goodsId = undefined
        }
        const choose = JSON.parse(JSON.stringify(this.addForm.choose))
        const labelIds = JSON.parse(JSON.stringify(this.addForm.labelIds))
        delete this.addForm.choose
        if (typeof (this.addForm.labelIds) === 'object') {
          let val = this.addForm.labelIds
          this.addForm.labelIds = val.join(',')
        }
        if(this.addForm.content){
          this.addForm.content = this.getHtml(this.addForm.content)
        }
        addArticle(this.addForm).then((response) => {
          if (response.code !== '0') {
            this.$set(this.addForm, 'choose', choose)
            this.$set(this.addForm, 'labelIds', labelIds)
          }
          let data = getData(response)
          if (data !== null) {
            this.$emit('refresh-list')
            this.addDialogVisible = false
          }
        })
      })
    }

  }
}
</script>

<style scoped lang='less'>
/deep/ .el-input {
  width: 90%;
}

</style>
